module.exports = __webpack_public_path__ + "static/media/logo-foco-menor.28e1bda5.svg";